"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAffiliationDisplay = exports.Affiliations = exports.AffiliationMap = exports.requiresPhoneVerification = exports.ArtistSizesRequiringPhone = exports.ArtistSizes = exports.ArtistSignupSteps = void 0;
const utils_1 = require("../utils");
// TODO: Incomplete typings
exports.ArtistSignupSteps = [
    "email",
    "artistSearch",
    "artistConfirm",
    "artistAffiliation",
    "contactInfo",
    "additionalInfo",
    "verificationSent",
    "enterPhone",
    "verifyPhone",
    "phoneConfirmed",
    "requestSent",
    "accountCreated",
    "enterPassword",
    "artistSelect",
];
exports.ArtistSizes = ["tiny", "small", "medium", "large"];
/**
 * Artist sizes for which a verified phone number is required before someone
 * can join the group.
 *
 * This mirrors what the signup wizard enforces -- see the `enterPhone` step
 * and the `yourAffiliation` transition in the signup app.  The requirement is
 * currently spelled out inline in several places that don't all agree; prefer
 * `requiresPhoneVerification` in new code.
 */
exports.ArtistSizesRequiringPhone = ["medium", "large"];
const requiresPhoneVerification = (size) => !!size && exports.ArtistSizesRequiringPhone.includes(size);
exports.requiresPhoneVerification = requiresPhoneVerification;
exports.AffiliationMap = {
    artist: "Artist",
    "management-company": "Management Rep",
    marketing: "Marketing Rep",
    label: "Label Rep",
    crew: "Tour Crew Rep",
    other: "Other",
    fan: "Fan",
};
exports.Affiliations = (0, utils_1.enumKeys)(exports.AffiliationMap);
/**
 * Safely get `AffiliationDisplay` from a string or undefined value.  If the
 * provided `affiliation` can't be mapped onto an `AffiliationDisplay` then
 * this returns a default ("Other").
 */
const getAffiliationDisplay = (affiliation) => {
    if (affiliation && affiliation in exports.AffiliationMap) {
        exports.AffiliationMap[affiliation];
    }
    return "Other";
};
exports.getAffiliationDisplay = getAffiliationDisplay;
//# sourceMappingURL=types.js.map